import type { ReactNode } from 'react'
import { Link, type LinkProps } from 'react-router'
import {
  type ButtonClassProps,
  getButtonClasses,
} from '#utils/getButtonClasses.ts'

interface ButtonLinkProps extends Omit<ButtonClassProps, 'theme'>, LinkProps {
  children: ReactNode
  theme?: 'primary' | 'secondary' | 'subtle'
}

/**
 * A link that looks like button
 */
export function ButtonLink({
  children,
  className,
  rounding,
  prefetch = 'intent',
  size,
  theme = 'secondary',
  width,
  ...props
}: ButtonLinkProps) {
  return (
    <Link
      className={getButtonClasses({ className, rounding, size, theme, width })}
      prefetch={prefetch}
      {...props}
    >
      {children}
    </Link>
  )
}
